import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import FreeBetView from 'modules/betslip/betslip-view/free-bets-list/free-bet/index.js';
import { connect } from 'react-redux';

const ExpandableView = MojitoPresentation.Components.ExpandableView;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const CurrencyHelper = MojitoPresentation.Utils.CurrencyHelper;
const {
    actions: betslipActions,
    utils: BetslipUtils,
    selectors: { selectBetslipStatus },
} = MojitoServices.Betslip;
const BetslipTypes = MojitoServices.Betslip.types;

const { selectCurrency } = MojitoServices.UserInfo.selectors;
const UserBonusesUtils = MojitoServices.UserBonuses.utils;

class FreeBetsList extends UIViewImplementation {
    constructor(props) {
        super(props);
        this.state = {
            selectedFreeBetId: BetslipUtils.getFreeBet(props.betslip),
        };
        this.renderFreeBetView = this.renderFreeBetView.bind(this);
        this.toggleFreeBet = this.toggleFreeBet.bind(this);
    }

    static getDerivedStateFromProps(props) {
        return {
            selectedFreeBetId: BetslipUtils.getFreeBet(props.betslip),
        };
    }

    toggleFreeBet(freeBet) {
        const { id, name } = freeBet;
        const { selectedFreeBetId } = this.state;
        if (!selectedFreeBetId || selectedFreeBetId === freeBet.id) {
            this.props.dispatch(betslipActions.toggleFreeBet({ token: id, name }));
        }
    }

    isSelected(freeBetId) {
        return freeBetId === this.state.selectedFreeBetId;
    }

    isDisabled(freeBetId) {
        if (this.props.isBetslipPending) {
            // Disable all toggle buttons if there is pending request to the backend
            return true;
        }

        const { freeBetConstraints = {} } = this.props;
        const { policy, tokens } = freeBetConstraints;
        if (policy === BetslipTypes.CONSTRAINT_POLICY.USABLE_TOKENS) {
            return !tokens.includes(freeBetId);
        }

        return Boolean(this.state.selectedFreeBetId && freeBetId !== this.state.selectedFreeBetId);
    }

    renderFreeBetView(freeBet) {
        const { id, name } = freeBet;
        const amount = UserBonusesUtils.getRemainingAmount(freeBet);
        const formattedAmount = CurrencyHelper.formatCurrency(amount, this.props.currencyCode);
        const title = `${formattedAmount} ${name || id}`;

        return (
            <FreeBetView
                config={this.config.freeBetView}
                freeBet={freeBet}
                key={id}
                title={title}
                selected={this.isSelected(id)}
                disabled={this.isDisabled(id)}
                toggleCallback={this.toggleFreeBet}
            />
        );
    }

    render() {
        const freeBetsList = this.props.freeBets.map(this.renderFreeBetView);
        return (
            <ExpandableView
                headerText={this.resolveAndFormatString('$BETSLIP.FREE_BETS', freeBetsList.length)}
                config={this.config.expandableView}
                class="ta-vouchersExpandableView"
            >
                <div className="ta-voucherList">{freeBetsList}</div>
            </ExpandableView>
        );
    }
}

const mapStateToProps = state => ({
    isBetslipPending: BetslipUtils.isPendingPlace(selectBetslipStatus(state)),
    currencyCode: selectCurrency(state),
});

export default connect(mapStateToProps)(FreeBetsList);
